const appWrapper = () => {
    const selectors = {
        appWrapperSection: '[data-app-wrapper]',
        accordion: '[data-app-wrapper-accordion]',
        accordionTitle: '[data-app-wrapper-accordion-title]',
        accordionContent: '[data-app-wrapper-accordion-content]',
    };
    const classes = {
        accordionOpen: 'app-wrapper__accordion--open',
    };
    const openAccordion = (accordion) => {
        const content = accordion.querySelector(selectors.accordionContent);
        if (!content)
            return;
        accordion.classList.add(classes.accordionOpen);
        content.style.maxHeight = content.scrollHeight + 'px';
    };
    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(selectors.accordionContent);
        if (!content)
            return;
        accordion.classList.remove(classes.accordionOpen);
        content.style.maxHeight = null;
    };
    const appWrapperSections = document.querySelectorAll(selectors.appWrapperSection);
    appWrapperSections.forEach((section) => {
        const accordion = section.querySelector(selectors.accordion);
        const title = section.querySelector(selectors.accordionTitle);
        const content = section.querySelector(selectors.accordionContent);
        if (!accordion)
            return;
        if (title && content) {
            title.onclick = () => {
                if (content.style.maxHeight) {
                    closeAccordion(accordion);
                }
                else {
                    openAccordion(accordion);
                }
            };
        }
        window.addEventListener('resize', () => {
            const content = accordion.querySelector(selectors.accordionContent);
            if (content && content.style.maxHeight) {
                openAccordion(accordion);
            }
        });
    });
};
export { appWrapper };
